import { Font } from "@moneyforward/mfx_biz_react_components";
import { Badge } from "@/components/atoms/Badge";
import React, { useContext } from "react";
import { PlanBoxContext } from "@/components/molecules/PlanBox";
import {
  filterActiveOtherServices,
  filterMikatanoServices,
} from "@/libs/billing/service";
import { BadgeContainer } from "@/components/atoms/BadgeContainer";
import { Divider } from "@/components/atoms/utilities/Divider";
import { calcPlanPrice, calcPlanPriceIncludingTax } from "@/libs/billing/plan";
import { OptionStatus } from "@/generated/graphql_billing";

type Props = {
  isPlanPriceTaxExcluded?: boolean;
};

export const PlanBoxPlanDetail = ({ isPlanPriceTaxExcluded }: Props) => {
  const ctx = useContext(PlanBoxContext);
  if (!ctx) {
    throw new Error("PlanBoxPlanDetail must be used inside PlanBox");
  }

  const { plan, optionContracts } = ctx;

  const mikatanoServices = filterMikatanoServices(plan.services);
  const otherServices = filterActiveOtherServices(plan.services);
  const otherServicesList = otherServices
    .map((service) => service.name)
    .join(" / ");
  const contractedOptions = optionContracts.filter(
    (opt) => opt.status === OptionStatus.Active
  );
  const planPrice = isPlanPriceTaxExcluded
    ? calcPlanPrice(plan)
    : calcPlanPriceIncludingTax(plan);

  return (
    <div css={{ display: "flex", flexDirection: "column", gap: 8 }}>
      <div css={{ display: "flex", gap: 8 }}>
        <div
          css={{
            display: "flex",
            flexDirection: "column",
            flexGrow: 1,
            gap: 8,
          }}
        >
          {/* Title & Plan Name */}
          <Font variant="mb">プラン</Font>
          <Font>{plan.name}</Font>

          {/* Mikatano Services */}
          {mikatanoServices.length > 0 && (
            <BadgeContainer>
              {mikatanoServices.map((svc) => (
                <Badge
                  key={svc.id}
                  fill={true}
                  variant="secondary"
                  text={svc.name}
                />
              ))}
            </BadgeContainer>
          )}

          {/* Other Services */}
          {otherServices.length > 0 && (
            <Font variant="s">その他サービス： {otherServicesList}</Font>
          )}
        </div>
        <Font css={{ whiteSpace: "nowrap", alignSelf: "end" }}>
          {planPrice.toLocaleString()}円/月
        </Font>
      </div>

      {/* Options */}
      {contractedOptions.length > 0 && (
        <>
          <Divider />

          <div css={{ display: "flex", flexDirection: "column", gap: 8 }}>
            <Font variant="mb">オプション</Font>
            {contractedOptions.map((opt) => (
              <div
                key={opt.id}
                css={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Font>{opt.name}</Font>
                <Font css={{ whiteSpace: "nowrap" }}>
                  {opt.priceIncludingTax?.toLocaleString()}円/月
                </Font>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};
